export const alloggiati = {
  title: "Alloggiati Web",
  subtitle: "Notifica elettronica degli alloggiati — Polizia di Stato",

  fields: {
    utente: "Utente",
    password: "Contraseña",
    wskey: "WsKey",
    wskeyHint: "La WsKey se genera en el portal alloggiatiweb.poliziadistato.it → Gestione dispositivi.",
    tipoStruttura: "Tipo de alojamiento",
    idAppartamento: "ID Appartamento",
    idAppartamentoHint: "ID del apartamento registrado en Alloggiati Web.",
    keepBlank: "(dejar vacío para no cambiar)",
  },

  tipoOptions: {
    hotel: "Hotel / B&B / Casa vacanze",
    appartamento: "Appartamento gestito",
  },

  actions: {
    saveAndVerify: "Guardar y verificar",
    updateCredentials: "Actualizar credenciales",
    verifyConnection: "Verificar conexión",
    saving: "Guardando...",
    verifying: "Verificando...",
  },

  status: {
    connectionOk: "Credenciales guardadas y conexión verificada correctamente.",
    connectionError: "Error de conexión. Verifica las credenciales ingresadas.",
    connectionPending: "Conexión aún no verificada. Pulsa «Verificar conexión» para confirmar.",
  },

  validation: {
    utenteRequired: "El campo Utente es obligatorio.",
    passwordRequired: "La contraseña es obligatoria.",
    wskeyRequired: "La WsKey es obligatoria.",
    idAppartamentoRequired: "El ID del apartamento es obligatorio.",
  },

  toasts: {
    saveSuccess: "Credenciales guardadas y conexión verificada correctamente.",
    saveWarning: "Credenciales guardadas, pero la conexión no pudo verificarse.",
    saveError: "No se pudieron guardar las credenciales.",
    testSuccess: "Conexión con Alloggiati Web verificada correctamente.",
    testError: "No se pudo verificar la conexión.",
    statusActive: "Alloggiati Web activado.",
    statusInactive: "Alloggiati Web desactivado.",
  },
};
